<template>
  <main
    class="w-full h-screen lg:pt-32 pt-6 container mx-auto flex flex-col lg:flex-col-reverse lg:justify-between">
    
    <NavLinks class="mb-12"/>
    
    <router-view/>

  </main>
</template>

<script>
  import NavLinks from '@/components/NavLinks'

  export default {
    name: 'App',
    components: {
      NavLinks
    }
  }
</script>

<style src="./assets/tailwind.css">
  
</style>
